import { Component, OnInit } from '@angular/core';
import { SCopyCaseEntryService } from '../pages/copy-case/copy-case-entry/s-copy-case-entry.service';

@Component({
  selector: 'app-print-case-annex-v-i-report',
  templateUrl: './print-case-annex-v-i-report.component.html',
  styleUrls: ['./print-case-annex-v-i-report.component.scss']
})
export class PrintCaseAnnexVIReportComponent implements OnInit {

  todays_date= new Date()
  breadCrumbItems: Array<{}>;

  constructor(public objSCopyCaseEntryService: SCopyCaseEntryService) { }

  ngOnInit(): void {
    this.objSCopyCaseEntryService.getCopyCasesVi()
  }
}
